import React, { useEffect, useState } from "react";
//import { Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { UserActivityAxios } from "../../API";
import { TextInput } from "../../shared/inputs";
import CdxModal from "../../shared/modal/CdxModal";

const RewardPoints = (props) => {
  let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };
  const [show, setShow] = React.useState(false);
  const [points, setPoints] = React.useState();
  const [showError, setShowError] = React.useState(false);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");

  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  const pointTypes = useSelector((state) => state.auth.pointTypes);

  useEffect(() => {
    if (!show) {
      setShowError(false);
      setShowSuccess(false);
    }
  }, [show]);

  const awardPoints = (e) => {



    e.preventDefault();
    var temp = pointTypes.filter((x) => x.useForReward === true)[0];
    // temp = undefined
    console.log(temp);
    if (points > 300) {
      setShowError(true);
      return;
    }
    if (!temp) {
      setShowError(true);
      setErrorText("No point type found");
      return;
    } else {
      setErrorText("");
    }
    var data = [
      {
        OfferingId: loggedInUser.offeringId,
        MissionId: loggedInUser.missionId,
        TeamId: loggedInUser.teamId,
        OfferingUserId: props.comment.offeringUserId,
        ActionKey: props.comment.id,
        PointsType: parseInt(temp.typeKey),
        PointsEarned: points,
        PointsAllocatedBy: loggedInUser.offeringUserId,
      },
    ];
    var requestObject = {
      requestModel: data,
      message: messagePoint,
      isBackgroundJob: false,
    };

    UserActivityAxios.post("UserPoint/adduserpoint", requestObject)
      .then(function (reponse) {
        setShowSuccess(true);
      })
      .catch(function (error) {
        console.log(error);
      });


  };

  const handleClose = () => {
    setShow(false);
    setPoints(0);
  };

  const [showValidation, setShowValidation] = useState(false);

  const handleCheckAndOpen = () => {
    setShowValidation(false);
    //get and chek if points are already rewarded
    UserActivityAxios.get(`UserPoint/checkifbonuspointawarded/${loggedInUser.offeringUserId}/${props.comment.offeringUserId}/${props.comment.id}`)
      .then(function (res) {
        if (!res.data) {
          setShow(true);
        }
        else {
          setShow(true);
          setShowValidation(true);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <>
      <div
        onClick={handleCheckAndOpen}
        className="reward-button"
      >
        <div className="icon" /> Reward
      </div>
      <CdxModal
        show={show}
        onHide={handleClose}
        animation={false}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        noBorder={false}
      >
        <form onSubmit={awardPoints}>
          <CdxModal.Header onClose={handleClose}>
            {props.comment.userProfile && (
              <div className="f-18">
                {"Reward " +
                  props.comment.userProfile.firstName +
                  " " +
                  props.comment.userProfile.lastName}
              </div>
            )}
          </CdxModal.Header>
          <CdxModal.Body>
            {showSuccess ? (
              props.comment &&
              props.comment.userProfile && (
                <div className="text-center mt-2">
                  <h4 className="color-primary fw-6">{points}</h4>
                  <h6>bonus points</h6>
                  awarded to{" "}
                  <span className="color-primary fw-6">
                    {props.comment.userProfile.firstName}{" "}
                    {props.comment.userProfile.lastName}!
                  </span>
                </div>
              )
            ) : (showValidation ? (
              <div className="text-center mt-2">
                Bonus points are already
                awarded to{" "}
                <span className="color-primary fw-6">
                  {props.comment.userProfile.firstName}{" "}
                  {props.comment.userProfile.lastName}!
                </span>
              </div>
            ) :
              (<>
                <TextInput
                  placeholder=""
                  label="Bonus Points"
                  className="reward-input p-0"
                  type="number"
                  value={points}
                  required
                  errorText="Please enter points between 1 to 300."
                  min={1}
                  max={300}
                  hasError={(e) => setShowError(e)}
                  onClick={(e) => e.target.select()}
                  onChange={(e) => setPoints(parseInt(e.target.value))}
                />
                Note: You can reward up to 300 bonus points!
                {errorText && (
                  <div className="text-danger mt-2">{errorText}</div>
                )}
              </>)
            )}
          </CdxModal.Body>
          <CdxModal.Footer className="reward-footer">
            {(showSuccess || showValidation) ? (
              <button className="cdx-btn" onClick={handleClose}>
                Close
              </button>
            ) : (
              <button type="submit" className="cdx-btn">
                Reward
              </button>
            )}
            {/* <Button variant="secondary" onClick={handleCloseReward}>
                        
                    </Button> */}
          </CdxModal.Footer>
        </form>
      </CdxModal>
    </>
  );
};

export default RewardPoints;
